/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 17:53:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-30 11:18:16
 * @FilePath: /goldenSalesMobile/src/api/order.js
 * @Description: 商户、门店、设备审核相关api
 */
import { requestOfPut, requestOfGet,requestOfPost } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/vpn'



export function getMerchantAuthList(param) {
  return requestOfPost(baseUrl+'/MerchantPageList', param)
}
export function authMerchant(param) {
  return requestOfGet(baseUrl+'/MerchantAudit', param)
}
export function getVpnAuthList(param) {
  return requestOfPost(baseUrl+'/VpnPageList', param)
}
export function authVpn(param) {
  return requestOfGet(baseUrl+'/VpnAudit', param)
}
export function getEquipAuthList(param) {
  return requestOfPost(baseUrl+'/DevicePageList', param)
}
export function activeEquip(param) {
  return requestOfGet(baseUrl+'/DeviceAudit', param)
}
export function getAllMerchants(param) {
  return requestOfGet(baseUrl+'/SearchMerchants', param)
}
export function unlockTenant(param) {
  return requestOfGet(baseUrl+'/ChangeLockoutEnabled', param)
}






